import dynamic from 'next/dynamic';
import { useContext, useState } from 'react';
import MobileFilters from '@/MainLayout/MobileFilters';
import { SearchInputWrapper } from '@/MainLayout/SearchHeader/SearchHeader.styles';
import { useIsMobile } from '~/contexts/DeviceContext';
import ModalContext from '~/contexts/ModalContext';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import useTrackRendered from '~/hooks/useTrackRendered';
import { useKeywordSearch } from './hooks';

const KeywordSearch = dynamic(
  () => import(/* webpackChunkName: "KeywordSearch" */ './KeywordSearch')
);

const SearchBar = dynamic(
  () => import(/* webpackChunkName: "SearchBar" */ './SearchBar')
);

const SearchBarModal = dynamic(
  () =>
    import(/* webpackChunkName: "SearchBarModal" */ '@/Modals/SearchBarModal'),
  { ssr: false }
);

type OwnProps = {
  isStickySearchBar: boolean;
};

export default function KeywordSearchWrapper({ isStickySearchBar }: OwnProps) {
  const isInDefaultSuggestionsExperiment = useCheckExperimentBucket(
    'srch-home-text-search-default',
    'experiment'
  );
  const { isSearchBarModalOpen, isSearchBarFocused } = useContext(ModalContext);
  const [inputValue, setInputValue] = useState('');
  const { inputFocus, setInputFocus } = useKeywordSearch();
  const isMobile = useIsMobile();
  const keywordSearchProps = {
    inputFocus,
    setInputFocus
  };
  const shouldFire = inputFocus || isSearchBarFocused || isSearchBarModalOpen;
  useTrackRendered('srch-home-text-search-default', shouldFire);

  return (
    <SearchInputWrapper>
      {isInDefaultSuggestionsExperiment ? (
        <SearchBar inputValue={inputValue} setInputValue={setInputValue} />
      ) : (
        <KeywordSearch
          {...keywordSearchProps}
          isStickySearchbar={isStickySearchBar}
        />
      )}
      <MobileFilters isStickySearchBar={isStickySearchBar} />
      {isInDefaultSuggestionsExperiment && isMobile && (
        <SearchBarModal inputValue={inputValue} setInputValue={setInputValue} />
      )}
    </SearchInputWrapper>
  );
}
